import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import * as Constants from "../../../models/Constants";
import {smoothlyMenu} from '../../../app.helpers';
declare var jQuery:any;

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html'
})
export class TopnavbarComponent {
    private nameMap = { MED: Constants.PRODUCT_TYPE_MEDICINE, 
                              FOOD : Constants.PRODUCT_TYPE_FOOD,
                              TOB : Constants.PRODUCT_TYPE_TOBACCO }

    constructor(private router: Router, private accountService: AccountService) {
    }

    getDepartmentName() {
      return this.buildString(this.accountService.getUserDepartmentCodes());
    }

    buildString(userDepartmentCodes){
      switch(userDepartmentCodes.length){
        case 1:
          return `${this.nameMap[userDepartmentCodes[0]]} Department`;
        case 2:
          userDepartmentCodes.sort();
          return `${this.nameMap[userDepartmentCodes[0]]} and ${this.nameMap[userDepartmentCodes[1]]} Department`;
        case 3:
          return 'Food, Medicine and Tobacco Department';
        default:
          return '';
      }
    }

    toggleNavigation(): void {
      jQuery('body').toggleClass('mini-navbar');
      smoothlyMenu();
    }
}
